export default "__VITE_ASSET__DCmGLq0U__"